export function randomRange(from: number, to: number): number {
    return from+Math.random()*(to-from);
}
export function irandomRange(from: number, to: number) {
    return Math.floor(randomRange(from, to));
}